/* Wolf Bros – product gallery by color
   1) Selecting a color moves ALL of that color's images to the front of the
      gallery, followed by the rest of the images (images are grouped in order:
      each color's first variant image starts its group).
   2) If the chosen color + size combination does not exist, the gallery still
      switches to the selected color. */
(function () {
  if (window.__wbVariantMediaFix) return;
  window.__wbVariantMediaFix = true;

  const COLOR_RE = /colou?r|لون/i;

  function getProduct(pi) {
    const url = pi.dataset.url;
    if (!url) return Promise.resolve(null);
    pi._wbProduct = pi._wbProduct || fetch(url + '.js').then((r) => r.json()).catch(() => null);
    return pi._wbProduct;
  }

  function buildGroups(product) {
    const names = product.options.map((o) => (typeof o === 'string' ? o : o.name));
    const idx = names.findIndex((n) => COLOR_RE.test(n));
    if (idx < 0) return null;
    const media = product.media || [];
    if (!media.length) return null;
    const order = new Map(media.map((m, i) => [String(m.id), i]));
    const start = {};
    product.variants.forEach((v) => {
      const fm = v.featured_media;
      if (!fm || !order.has(String(fm.id))) return;
      const color = v.options[idx];
      const i = order.get(String(fm.id));
      if (!(color in start) || i < start[color]) start[color] = i;
    });
    const colors = Object.keys(start).sort((a, b) => start[a] - start[b]);
    if (colors.length < 2) return null;
    const mediaColor = new Map();
    media.forEach((m, i) => {
      let owner = colors[0];
      for (const c of colors) if (start[c] <= i) owner = c;
      mediaColor.set(String(m.id), owner);
    });
    return { idx, name: names[idx], mediaColor, start, media };
  }

  function selectedColor(pi, name) {
    const el = Array.from(pi.querySelectorAll('variant-selects [data-option-name]')).find(
      (e) => e.dataset.optionName === name && (e.checked || e.selected)
    );
    return el ? el.value : null;
  }

  async function apply(pi, activate) {
    try {
      const product = await getProduct(pi);
      if (!product) return;
      pi._wbGroups = pi._wbGroups || buildGroups(product) || false;
      const g = pi._wbGroups;
      if (!g) return;
      const color = selectedColor(pi, g.name);
      if (!color || !(color in g.start)) return;
      const section = pi.dataset.section;
      const gallery = pi.querySelector('media-gallery');
      if (!gallery) return;
      const idOf = (val) => (val || '').replace(section + '-', '');

      // Put the selected color's images first, then all the other images in their normal order.
      const ordered = g.media
        .filter((m) => g.mediaColor.get(String(m.id)) === color)
        .concat(g.media.filter((m) => g.mediaColor.get(String(m.id)) !== color));
      const reorder = (attr) => {
        const items = Array.from(gallery.querySelectorAll(`li[${attr}]`));
        if (!items.length) return;
        const byId = new Map(items.map((li) => [idOf(li.getAttribute(attr)), li]));
        const parent = items[0].parentElement;
        ordered.forEach((m) => {
          const li = byId.get(String(m.id));
          if (li) {
            li.style.display = '';
            parent.appendChild(li);
          }
        });
      };
      reorder('data-media-id');
      reorder('data-target');

      if (activate) {
        const first = g.media[g.start[color]];
        if (first) gallery.setActiveMedia?.(`${section}-${first.id}`, true);
      }

      gallery.querySelectorAll('slider-component').forEach((s) => {
        try {
          s.resetPages?.();
          s.initPages?.();
        } catch (e) {}
      });
    } catch (e) {
      console.error(e);
    }
  }

  customElements.whenDefined('product-info').then(() => {
    const ProductInfo = customElements.get('product-info');

    const origUnavailable = ProductInfo.prototype.setUnavailable;
    ProductInfo.prototype.setUnavailable = function () {
      origUnavailable.apply(this, arguments);
      setTimeout(() => apply(this, true), 0);
    };

    const origUpdateOptionValues = ProductInfo.prototype.updateOptionValues;
    ProductInfo.prototype.updateOptionValues = function () {
      const r = origUpdateOptionValues.apply(this, arguments);
      setTimeout(() => apply(this, true), 60);
      return r;
    };

    document.querySelectorAll('product-info').forEach((pi) => apply(pi, false));
  });
})();
